import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useMediaQuery, Typography } from '@material-ui/core';
import clsx from 'clsx';

// COMPONENTS
import RouterBreadcrumbs from '@/components/RouterBreadcrumbs';
import Sticky from '@/components/Sticky';

// STYLES
import { Container } from './styles';

const ContentHero = ({
  title,
  titleProps,
  subtitle,
  breadcrumbsProps,
  hideBreadcrumbs,
  children,
  leftBg,
  rightBg,
}) => {
  const { headerHeight, partner, partnerSettings } = useSelector(state => ({
    headerHeight: state.app.headerHeight,
    partner: state.partner.data,
    partnerSettings: state.partner.data?.settings || {},
  }));
  const matchesSmDown = useMediaQuery(({ breakpoints }) => breakpoints.up('sm'));

  const hasTheme = !!partner.theme;
  const useDarkContentHero = !!partner.theme?.useDarkContentHero;
  const subHeader =
    !partnerSettings.is_fake &&
    (partnerSettings.header_type === 'current_with_bar' ||
      partnerSettings.header_type === 'current_with_bar_and_reordered_links');
  const stickyTop = subHeader && headerHeight !== 0 ? 104 : headerHeight;

  return (
    <Container
      className={clsx(
        'content-hero',
        leftBg && 'content-hero--left-bg',
        rightBg && 'content-hero--right-bg',
        !(hasTheme && useDarkContentHero) && 'content-hero--lighten',
      )}
    >
      <div className="page-content">
        {!hideBreadcrumbs && (
          <RouterBreadcrumbs
            className={clsx(!(hasTheme && useDarkContentHero) && 'breadcrumbs breadcrumbs--light')}
            {...breadcrumbsProps}
          />
        )}
        {title && (
          <Typography
            className="content-hero__title"
            component="h1"
            variant={matchesSmDown ? 'h3' : 'h4'}
            {...titleProps}
          >
            {title}
          </Typography>
        )}
        {subtitle && <Typography className="content-hero__subtitle">{subtitle}</Typography>}
        {children && (
          <Sticky top={stickyTop} innerZ={1211}>
            <div className="content-hero__content">{children}</div>
          </Sticky>
        )}
      </div>
    </Container>
  );
};

ContentHero.defaultProps = {
  title: '',
  subtitle: '',
  titleProps: {},
  breadcrumbsProps: {},
  hideBreadcrumbs: false,
  leftBg: false,
  rightBg: false,
};

ContentHero.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  titleProps: PropTypes.object,
  subtitle: PropTypes.string,
  breadcrumbsProps: PropTypes.object,
  hideBreadcrumbs: PropTypes.bool,
  leftBg: PropTypes.bool,
  rightBg: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default React.memo(ContentHero);
